import { fromReservation, fromMarket } from 'store/selectors';
import memoize from 'lodash/memoize';

import {
  changeGuestNationality,
  changeGuestAge,
  changeGuestGender,
  changeGuestTitle,
  changeGuestSpecialNeeds,
  changeGuestDocumentType,
  changeGuestDocumentIssuingCountry,
} from 'store/actions';

import factory from './factory/DropdownContainerFactory';

const getMemoizedFilteredCategories = memoize((categories, valid) => categories.filter(c => valid.find(v => v.code === c.code)));
const getCustomerCategories = (state, { departureId }) =>
  getMemoizedFilteredCategories(fromMarket.getAges(state), fromReservation.getAgesForDeparture(state, departureId));


const getSelected = guestField => (state, { guestId }) => fromReservation.getGuest(state, guestId)[guestField];
const getAction = action => (value, { guestId }) => action(guestId, value);

const fields = {
  gender: [fromMarket.getGenders, getAction(changeGuestGender), getSelected('gender')],
  nationality: [fromMarket.getNationalities, getAction(changeGuestNationality), getSelected('nationality')],
  customerCategory: [getCustomerCategories, getAction(changeGuestAge), getSelected('customerCategory')],
  disabilityCode: [fromMarket.getSpecialNeeds, getAction(changeGuestSpecialNeeds), getSelected('disabilityCode')],
  documentType: [fromMarket.getDocumentTypes, getAction(changeGuestDocumentType), getSelected('documentType')],
  documentIssuingCountry: [fromMarket.getNationalities, getAction(changeGuestDocumentIssuingCountry), getSelected('documentIssuingCountry')],
  title: [fromMarket.getTitles, getAction(changeGuestTitle), getSelected('title')],
};

export default factory(fields);



// WEBPACK FOOTER //
// ./src/containers/GuestDropdown.js